import './IconTooltip.scss';
export const iconTooltipId = 'icon-tooltip';
//# sourceMappingURL=index.js.map